import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import "./reports.css";
import { FaChartLine, FaGamepad, FaGlobeEurope } from "react-icons/fa";
import { BiSolidDonateBlood } from "react-icons/bi";

const HeaderCharts = ({
  UserStatsDataReport,
  RevenueStatsDataReport,
  DonationsStatsDataReport,
  GamesStatsDataReport,
}) => {
  useEffect(() => {}, [
    UserStatsDataReport,
    RevenueStatsDataReport,
    DonationsStatsDataReport,
    GamesStatsDataReport,
  ]);
  const chartOptions = {
    options: {
      chart: {
        sparkline: {
          enabled: true,
        },
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      tooltip: {
        enabled: true,
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          title: {
            formatter: (seriesName) => "Value: ",
          },
        },
      },
      colors: ["#ffffff"],
      fill: {
        opacity: 0.3,
      },
    },
    series: [
      {
        data: [10, 42, 35, 51, 49, 62, 69, 91],
      },
    ],
  };
  return (
    <div
      className="row mb-4"
      style={{
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      <div className="col-12 col-sm-6 col-md-3 d-flex align-items-stretch">
        <div className="card bg-gradient-primary text-white shadow-sm border-0 p-3 rounded-4 w-100 h-100 d-flex flex-column">
          <div className="card-body d-flex flex-column justify-content-between">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="fw-bold">Total Revenue</h5>
                <h3>{`$${RevenueStatsDataReport?.totalAmount || "00"}`}</h3>
              </div>
              <FaChartLine className="fs-3" />
            </div>
            <div>
              <Chart
                options={chartOptions.options}
                series={[
                  {
                    data: RevenueStatsDataReport?.perMonth || [0, 0, 0, 0, 0],
                  },
                ]}
                type="line"
                height="50"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-6 col-md-3">
        <div className="card bg-gradient-success text-white shadow-sm border-0 p-3 rounded-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="fw-bold">Total Donation</h5>
                <h3>{`$${DonationsStatsDataReport?.totalAmount || "00"}`}</h3>
              </div>
              <BiSolidDonateBlood className="fs-3" />
            </div>
            <div>
              <Chart
                options={chartOptions.options}
                series={[
                  {
                    data: DonationsStatsDataReport?.perMonth || [0, 0, 0, 0],
                  },
                ]}
                type="line"
                height="50"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-6 col-md-3">
        <div className="card bg-gradient-warning text-dark shadow-sm border-0 p-3 rounded-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center text-light">
              <div>
                <h5 className="fw-bold" style={{ fontSize: "1.2rem" }}>
                  Registered Games
                </h5>
                <h3>{`${GamesStatsDataReport?.totalGames || "00"}`}</h3>
              </div>
              <FaGamepad className="fs-3" />
            </div>
            <div>
              <Chart
                options={chartOptions.options}
                series={[
                  {
                    data: GamesStatsDataReport?.perMonth || [0, 0, 0, 0],
                  },
                ]}
                // series={[{ data: [15, 30, 25, 45, 50, 60, 80] }]}
                type="line"
                height="50"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-6 col-md-3">
        <div className="card bg-gradient-info text-white shadow-sm border-0 p-3 rounded-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="fw-bold">Total Users</h5>
                <h3>{UserStatsDataReport?.totalUsers || "00"}</h3>
              </div>
              <FaGlobeEurope className="fs-3" />
            </div>
            <div>
              <Chart
                options={chartOptions.options}
                series={[
                  {
                    data: UserStatsDataReport?.perMonth || [0, 0, 0, 0],
                  },
                ]}
                // series={[
                //   {
                //     data: [
                //       19000, 1900, 1500, 2000, 25000, 3300, 3405, 44504,
                //     ],
                //   },
                // ]}
                type="line"
                height="50"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeaderCharts;
